import EventBus from "@packages/event-bus";
import Case from "case";
import loadsOnFilterUpdate from "./loads-on-filter-update";

export default {
    mixins: [loadsOnFilterUpdate],

    data() {
        return {
            loading: false,
            page: 1,
            identity: undefined,
        };
    },

    computed: {
        list() {
            if (!this.entity) throw new Error("Entity not specified");

            return this.$store.state[this.entity].list || [];
        },

        totalItems() {
            if (!this.entity) throw new Error("Entity not specified");

            return this.$store.state[this.entity].count || 0;
        },

        filters() {
            if (!this.entity) throw new Error("Entity not specified");

            return this.$store.state[this.entity].filters;
        },

        totalPages() {
            if (!this.sync.totalItems) return 0;

            return Math.ceil(this.sync.totalItems / this.sync.rowsPerPage);
        },

        sync: {
            get() {
                return {
                    descending: this.filters.desc,
                    page: this.page,
                    rowsPerPage: this.amountPerPage ? this.amountPerPage : 30,
                    sortBy: this.filters.orderBy,
                    totalItems: this.totalItems
                };
            },

            set(val) {
                const orderByChange = val.sortBy !== this.filters.orderBy;
                const descChange = val.descending !== this.filters.desc;

                if (orderByChange)
                    this.$store.commit(
                        `${Case.upper(this.entity)}_SET_FILTER`,
                        {
                            key: "orderBy",
                            value: val.sortBy
                        }
                    );

                if (descChange)
                    this.$store.commit(
                        `${Case.upper(this.entity)}_SET_FILTER`,
                        {
                            key: "desc",
                            value: val.descending
                        }
                    );

                if (orderByChange || descChange) this.load();
            }
        }
    },

    methods: {
        async load() {
            const payload = {
                method: this.method,
                countMethod: this.countMethod,
                key: this.entity,

                pagination: {
                    page: this.sync.page - 1,
                    amountPerPage: this.amountPerPage ? this.amountPerPage : 30
                },

                filters: this.filters
            };

            this.loading = true;

            await Promise.all([
                this.$loader.paginated.list(payload),
                this.$loader.paginated.count(payload)
            ])

            this.loading = false;
        },

        setPage(page) {
            this.page = page;
            this.load();
        },

        goToFirstPageHandler() {
            this.page = 1;
        }
    },

    mounted() {
        EventBus.$on("GO_TO_FIRST_PAGE", this.goToFirstPageHandler);

        if (!this.loadOnFilters) {
            this.load();
        }
    },

    beforeDestroy() {
        EventBus.$off("GO_TO_FIRST_PAGE", this.goToFirstPageHandler);
    }
};
